import React, { FC } from "react";

import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tag from "antd/es/tag";
import { defineMessages, useIntl } from "react-intl";

import { GuideStatus } from "@mapmycustomers/shared";
import { GuideUserStatus } from "@mapmycustomers/shared/types/entity";

import styles from "./UserGuidesList.module.scss";

const messages = defineMessages({
  none: {
    id: "onboarding.users.table.column.guides.none",
    defaultMessage: "None",
    description: "None text to be displayed when user has no guides assigned to them",
  },
});

export interface UserGuidesListProps {
  statuses: GuideUserStatus[];
}

const UserGuidesList: FC<UserGuidesListProps> = ({ statuses }) => {
  const intl = useIntl();

  return (
    <div>
      {statuses.length ? (
        statuses.map((guideStatus) => (
          <Tag
            color={guideStatus.status === GuideStatus.COMPLETED ? "success" : "default"}
            key={guideStatus.id}
          >
            {guideStatus.status === GuideStatus.COMPLETED && (
              <FontAwesomeIcon className={styles.checkIcon} icon={faCheck} />
            )}
            {guideStatus.guide.displayName}
          </Tag>
        ))
      ) : (
        <i className={styles.none}>{intl.formatMessage(messages.none)}</i>
      )}
    </div>
  );
};

export default UserGuidesList;
